<template>
    <footer class="footer-wrapper" id="contact-sec">
        <div class="container-fluid">
            <div class="footer-sec">
                <div class="row">

                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div class="footer-con">
                            <div class="footer-logo-con">
                            <div class="footer-logo">
                                <router-link  to="">
                                    <img src="/Agent/images/footer-logo.png" alt="">
                                </router-link> 
                            </div>
                            <div class="footer-contact-sec">
                                    <router-link  to="" class=" thm-social-btn call-footer-icon thm-heading-six"> <img src="/Agent/images/call-icon.svg" alt=""> <span> +91-6269010321, 22</span></router-link>
                                    <router-link  to="" class=" thm-social-btn thm-heading-six"> <img src="/Agent/images/whatsapp-icon.svg" alt=""> <span> +91-6269010323</span></router-link>
                                    <router-link   to="" class=" thm-social-btn thm-heading-six"> <img src="/Agent/images/mail-icon.svg" alt=""> <span> support@dreasyfly.com</span></router-link>
                                
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="col-lg-3  col-md-4 col-sm-4 col-12">
                        <div class="footer-con quick-links-sec">
                            <div class="footer-link-sec">
                                <h5 class="thm-heading-five">Quick Links</h5>
                                    <div class="footer-link-list quick-links-list">
                                        <ul>
                                            <li>
                                                <router-link  to=""  class="thm-heading-paragraph">About us</router-link>
                                            </li>
                                            <li>
                                                <router-link to=""   class="thm-heading-paragraph">FAQS</router-link>
                                            </li>
                                            <li>
                                                <router-link  to="" class="thm-heading-paragraph">Terms & Conditions  </router-link>
                                            </li>
                                            <li>
                                                <router-link to=""  class="thm-heading-paragraph">Privacy Policy</router-link>
                                            </li>
                                            <li>
                                                <router-link  to="" class="thm-heading-paragraph">Cancellation Policy </router-link>
                                            </li>
                                            <li>
                                                <router-link to=""  class="thm-heading-paragraph">Contact Us</router-link>
                                            </li>
                                        </ul>
                                    </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3  col-md-4 col-sm-12 col-12">
                        <div class="footer-con service-media-link">
                            <div class="footer-link-sec ">
                                <h5 class="thm-heading-five">Our Service</h5>

                                <div class="footer-link-list service-item">
                                    <ul>
                                        <li>
                                            <router-link  to=""  class="thm-heading-paragraph" @click="$router.replace('/agent/home/flight')">Flight</router-link>
                                        </li>
                                        <li>
                                            <router-link to=""   class="thm-heading-paragraph" @click="$router.replace('/agent/home/train')">Train</router-link>
                                        </li>
                                        <li>
                                            <router-link  to="" class="thm-heading-paragraph">Money Transfer </router-link>
                                        </li>
                                        <li>
                                            <router-link to=""  class="thm-heading-paragraph">Hotel</router-link>
                                        </li>
                                        <li>
                                            <router-link  to="" class="thm-heading-paragraph">Bus </router-link>
                                        </li>
                                        <li>
                                            <router-link to=""   class="thm-heading-paragraph">Recharge</router-link>
                                        </li>
                                        <li>
                                            <router-link to=""    class="thm-heading-paragraph">Holiday</router-link>
                                        </li>
                                        <li>
                                            <router-link  to=""   class="thm-heading-paragraph" @click="$router.replace('/agent/home/tourismBooking')">Irctc Tourism </router-link>
                                        </li>
                                        <li>
                                            <router-link to="" class="thm-heading-paragraph">Visa</router-link>
                                        </li>   
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3  col-md-12 col-sm-12  col-12">
                        <div class="footer-con social-url-sec">
                            <div class="footer-link-sec">
                                <h5 class="thm-heading-five">Follow</h5>

                                <div class="social-media-sec">
                                    <ul>
                                        <li>
                                            <router-link  to="" ><img src="/Agent/images/facebook.svg" alt=""></router-link>
                                        </li>
                                        <li>
                                            <router-link to=""  ><img src="/Agent/images/twitter.svg" alt=""></router-link>
                                        </li>
                                        <li>
                                            <router-link  to="" ><img src="/agent/images/linkedin.svg" alt=""> </router-link>
                                        </li>
                                        <li>
                                            <router-link to="" ><img src="/agent/images/instagram.svg" alt=""></router-link>
                                        </li>
                                       
                                    </ul>
                                </div>
                                <div class="currency-language-sec">
                                    <p  class="thm-heading-paragraph">Choose Your Currency/Language</p>
                                    <div class="currency-language-con">
                                        <select id="INR" class="form-select thm-heading-paragraph" aria-label="Default select example">
                                            <option  selected value="1">INR</option>
                                            <option  value="2">GBP</option>
                                            <option  value="3">JPY</option>
                                            <option  value="4">CAD</option>
                                            <option  value="5">AUD</option>
                                        </select>
                                        <select id="language"  class="form-select thm-heading-paragraph" aria-label="Default select example">
                                            <option lang="en" value="english" selected>English</option>
                                            <option lang="de" value="deutsch">Deutsch</option>
                                            <option lang="fr" value="francais">Hindi</option>
                                            <option lang="it" value="italiano">Italiano</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                 
                </div>
            </div>
        </div>
        <div class="copyright-con text-center">
             <p class="thm-heading-small ">Copyright &copy; <span>{{ currentYear }}</span>  Simplyyatra.com, All rights reserved.</p>
        </div>
    </footer>
</template>
<script>
 export default{
    name:"FooterView",
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
 }
</script>